import React from 'react';
import './MarkerList.css';
import Marker from '../Marker/Marker';

const MarkerList = ({ language, location }) => {

    // render html
    return(
        <div className={`markerList`}>
            <Marker path={`/${location}/${language}/wrong`} left={57} top={75} />
            <Marker path={`/${location}/${language}/wrong`} left={27} top={41} />
            <Marker path={`/${location}/${language}/wrong`} left={11} top={49} />
            <Marker path={`/${location}/${language}/wrong`} left={85} top={53} />
            <Marker path={`/${location}/${language}/wrong`} left={65} top={23} />
            <Marker path={`/${location}/${language}/wrong`} left={75} top={38} />
            <Marker path={`/${location}/${language}/wrong`} left={57} top={57} />
            <Marker path={`/${location}/${language}/wrong`} left={26} top={77.8} />
            <Marker path={`/${location}/${language}/wrong`} left={56} top={37.5} />

            { (location === 'bxl') ? (
                <Marker path={`/${location}/${language}/correct`} left={65} top={66.7} />
            ) : (location === 'ant') ? (
                <Marker path={`/${location}/${language}/correct`} left={60} top={65.2} />
            ) : (location === 'lie') ? (
                <Marker path={`/${location}/${language}/correct`} left={71.6} top={50.2} />
            ) : (
                <Marker path={`/${location}/${language}/correct`} left={75} top={58.8} />
            )}
        </div>
    );
}

export default MarkerList;